import React from 'react';

import { Stack, Typography } from '@metarouter-private/mr-mui';

export default function ConfirmOverrideMessage() {
  return (
    <Stack spacing={2}>
      <Typography>
        <Typography fontWeight="700" component="span">
          Warning:
        </Typography>{' '}
        Using Organization Override will eliminate all other sessions you have running in other tabs or windows.
      </Typography>

      <Typography>Ensure you have saved any work in other tabs or windows before overriding.</Typography>
    </Stack>
  );
}
